import Instance from "../../../Axios";

// New Actions for the app

const EmitirContratoById = (id) => async (dispatch) => {
  await Instance()
    .put(`/plus/adesoes/emitirContrato/${id}`)
    .then(({ data }) => {
      dispatch({ type: "EMITIR_CONTRATO_BY_ID", payload: data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default EmitirContratoById;
